var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-radio-container"},[_c('el-radio',{attrs:{"value":_vm.value,"label":_vm.label,"name":_vm.name,"size":_vm.size,"border":_vm.border,"disabled":_vm.disabled},on:{"change":_vm.changeFun,"input":_vm.inputFun}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }